import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import {
  onAfterSortChanged,
  getRowHeight,
  onAfterFilterChanged,
} from '../../../../datacenter/app/js/services/tableData';
import downloadCSV from '../../services/downloadCSV';
import { waitTillExists } from '../../services/util';
import * as styles from './index.css';
import Lightbox from '../lightbox';

/**
 * CSS got to disable eslint, as the import catchers yell at you...
 */
/* eslint-disable */
import '!!style!css!postcss!sass!../../../node_modules/ag-grid/dist/styles/ag-grid.css';
import '!!style!css!postcss!sass!../../../../datacenter/app/styles/datacenter-ng-theme.scss';
import '!!style!css!postcss!sass!./ng-theme-overrides.scss';
/* eslint-enable */

class Table extends Component {
  constructor() {
    super();
    this.state = {
      lightbox: false,
    };

    // Local Events & Functions
    this.onOpen = this.onOpen.bind(this);
    this.renderLightbox = this.renderLightbox.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.adjustToolBar = this.adjustToolBar.bind(this);

    // AG Grid Jazz
    this.onGridReady = this.onGridReady.bind(this);
    this.lightboxOnGridReady = this.lightboxOnGridReady.bind(this);
    /**
     * We need to refresh the view for ranking...
     * should probably do this differntly
     */
    this.onAfterSortChanged = () => {
      this.api.refreshView();
      onAfterSortChanged.bind(this)();
    };
    this.onAfterFilterChanged = onAfterFilterChanged.bind(this);
  }

  componentDidMount() {
    waitTillExists(
      '.ag-body-container',
      () => this.adjustToolBar()
    );
  }

  onGridReady({ api, columnApi }) {
    this.api = api;
    this.api.footnoteCallback = this.props.table.footnoteCallback;
    this.columnApi = columnApi;
    this.headerStyle = 'bold 14px/18px "Open Sans", helvetica, sans-serif';
    /**
     * Because we don't have have a filter to trigger this,
     * trigger filter change to set column headers
     */
    this.onAfterFilterChanged();
  }

  onOpen() {
    this.setState({
      lightbox: !this.state.lightbox,
    });
  }

  lightboxOnGridReady({ api, columnApi }) {
    const lightboxGrid = { api, columnApi };
    lightboxGrid.api.footnoteCallback = this.props.table.footnoteCallback;
    lightboxGrid.headerStyle =
      'bold 14px/18px "Open Sans", helvetica, sans-serif';

    // Can't override a .bind call - so using imported onAfterFilterChanged
    onAfterFilterChanged.call(lightboxGrid);
  }

  adjustToolBar() {
    // Adjust button nav here
    const width =
      Array.prototype.reduce.call(
        this.parentElm.querySelector('.ag-body-container .ag-row').querySelectorAll('.ag-cell'),
        (acc, curr) => acc + curr.getBoundingClientRect().width, 0
      ) +
      this.parentElm
        .querySelector('.ag-pinned-left-cols-viewport')
        .getBoundingClientRect()
        .width;
    if (800 > width || (
      document.querySelector('.no-sidebar') &&
      1225 > width
    )) {
      this.parentElm
        .querySelector(`.${styles.toolBar}`)
        .style
        .width = `${width}px`;
    }
  }

  /* eslint-disable no-alert */
  exportCSV() {
    if (-1 < window.navigator.userAgent.indexOf('Safari') &&
      0 > window.navigator.userAgent.indexOf('Chrome')) {
      if (
        !confirm('CSV will open in a new browser window, please save as a CSV')
      ) {
        return;
      }
    }
    downloadCSV(
      this.api,
      this.props.table,
      this.props.timeframes,
      this.props.config,
      this.props.immutableHeaders,
      this.props.immutableDataviews
    );
  }
  /* eslint-enable no-alert */

  renderLightbox() {
    if (!this.state.lightbox) {
      return null;
    }
    const header = this.container.querySelector('.ag-header');
    const body = this.container.querySelector('.ag-body-container');
    const leftCols = this.container
      .querySelector('.ag-pinned-left-cols-viewport');

    const wrapperStyle = {
      height: header.getBoundingClientRect().height +
        body.getBoundingClientRect().height + 10,
      width: body.getBoundingClientRect().width +
        leftCols.getBoundingClientRect().width,
    };

    const style = { height: 'inherit', width: 'inherit' };
    const lightboxOnAfterFilterChanged =
      this.onAfterFilterChanged.bind({ ...this, forPrint: true });

    return (
      <Lightbox
        onClose={this.onOpen}
        wrapperStyle={wrapperStyle}
      >
        <div
          className={styles.tableWrapperLightbox}
          style={wrapperStyle}
          ref={(container) => { this.container = container; }}
        >
          <div
            className="ag-datacenter print"
            style={style}
          >
            <AgGridReact
              {...this.props.table}
              onGridReady={this.lightboxOnGridReady}
              onAfterSortChanged={this.onAfterSortChanged}
              onAfterFilterChanged={lightboxOnAfterFilterChanged}
              getRowHeight={getRowHeight}
            />
          </div>
        </div>
      </Lightbox>
    );
  }

  render() {
    const wrapperStyle = {
      height: (window.innerHeight * 0.75),
    };

    const style = {
      height: 'inherit',
      width: 'inherit',
    };

    const { sortable, table } = this.props;
    if (!sortable) {
      table.enableSorting = false;
    }

    return (
      <div ref={(parent) => { this.parentElm = parent; }}>
        {this.renderLightbox()}
        <div className={styles.toolBar}>
          <span className={styles.note}>Scroll in table</span>

          <div className={styles.btnBar}>
            <button
              className={styles.btn}
              onClick={this.onOpen}
            >View Full Table</button>
            <button
              className={styles.btn}
              onClick={this.exportCSV}
            >Export CSV</button>
          </div>
        </div>
        <div
          className={`table-wrapper ${styles.tableWrapper}`}
          style={wrapperStyle}
          ref={(container) => { this.container = container; }}
        >
          <div
            className="ag-datacenter"
            style={style}
          >
            <AgGridReact
              {...table}
              onGridReady={this.onGridReady}
              onAfterSortChanged={this.onAfterSortChanged}
              onAfterFilterChanged={this.onAfterFilterChanged}
              getRowHeight={getRowHeight}
            />
          </div>
        </div>
      </div>
    );
  }
}

Table.propTypes = {
  sortable: React.PropTypes.boolean,
  table: React.PropTypes.object,
  config: React.PropTypes.any,
  immutableHeaders: React.PropTypes.any,
  immutableDataviews: React.PropTypes.any,
  timeframes: React.PropTypes.array,
};

export default connect((state) => ({
  sortable: state.data.sortable,
  table: state.data.table,
  config: state.data.config,
  immutableHeaders: state.data.immutableHeaders,
  immutableDataviews: state.data.immutableDataviews,
  timeframes: state.data.timeframes,
}))(Table);



// WEBPACK FOOTER //
// ./app/components/table/index.js